import styled from 'styled-components';
import PropTypes from "prop-types";

const Base = styled.div`
    ${({space}) => 
        (space === 'Top' && 'margin-top: 48px') ||
        (space === 'TopDown' && 'margin: 48px 0 32px') || 
        (space === 'Down' && 'margin-bottom: 32px')
    };
`;

Base.propTypes = {
    space: PropTypes.string
};

export default Base;